import { render, staticRenderFns } from "./YBContainerEdit.vue?vue&type=template&id=24fc006c&"
import script from "./YBContainerEdit.vue?vue&type=script&lang=js&"
export * from "./YBContainerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports